import { ToggleFilterProps } from '~/components/update-filter-options/updateFilterOptions';
import {
  AssetsConstituents,
  indexAbbreviationToFullNameMap,
  SelectedAssetItem,
} from '~/views/dashboard/calendar-widget/calendar-event-drawer/drawer-content/run-scenario/RunScenario';
import { SCENARIO_ASSET_FILTER_KEY } from '~/widgets/scenario/hooks/use-scenario-store/filter-utils';

interface AddAssetFilterOptionsArgs {
  selectedAssets?: SelectedAssetItem;
  addAssetFilterOption: (props: ToggleFilterProps) => void;
}

export const addAssetFilterOptions = ({
  selectedAssets,
  addAssetFilterOption,
}: AddAssetFilterOptionsArgs) => {
  if (!selectedAssets) {
    return;
  }

  const { id, assetFilterValueKey } = selectedAssets;

  addAssetFilterOption({
    filterKey: SCENARIO_ASSET_FILTER_KEY,
    filterId: SCENARIO_ASSET_FILTER_KEY,
    multiselect: true,
    option: {
      key: id,
      name: id,
      value: {
        [assetFilterValueKey]: id,
      },
    },
  });
};

export const getPublicListId = (
  listName: AssetsConstituents,
  lists?: { name: string; id: string }[]
) => {
  return lists?.find(
    list => list.name === indexAbbreviationToFullNameMap[listName]
  );
};
